module.exports = __webpack_public_path__ + "static/media/writer.64ce6ba8.jpg";